/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function RequestContactSettingFieldValueValuesInnerFromJSON(json) {
    return RequestContactSettingFieldValueValuesInnerFromJSONTyped(json, false);
}
export function RequestContactSettingFieldValueValuesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        value: !exists(json, 'value') ? undefined : json['value']
    };
}
export function RequestContactSettingFieldValueValuesInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        value: value.value
    };
}
